import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowLeft } from 'lucide-react';

/** Shared header/frame for the blog index and post pages (mirrors PrivacyPolicy). */
export const BlogShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="min-h-screen bg-zinc-950 text-zinc-50">
    <header className="border-b border-zinc-900">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="text-yellow-400">
            <BookOpen size={22} strokeWidth={2.5} />
          </div>
          <span className="font-bold text-zinc-200">Hisab Kitab</span>
        </Link>
        <nav className="flex items-center gap-5 text-sm">
          <Link to="/blog" className="text-zinc-300 hover:text-yellow-400 transition-colors">
            Blog
          </Link>
          <Link
            to="/"
            className="flex items-center gap-1.5 text-zinc-500 hover:text-yellow-400 transition-colors"
          >
            <ArrowLeft size={16} />
            Home
          </Link>
        </nav>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">{children}</main>
  </div>
);
